type DashboardConfig = { name: string; url: string };

// tslint:disable:max-line-length
const dashboards: DashboardConfig[] = [
  {
    name: "Payments status",
    url:
      "https://service.eu.sumologic.com/ui/dashboard.html?k=cA5sPkumV3HwNT2G7HxCckJICPN5gi7TgifihJI42YlbUj5beF7Sfyd6fpoG&t=r"
  },
  {
    name: "Payment errors",
    url:
      "https://service.eu.sumologic.com/ui/dashboard.html?k=fLJlbqXWYNAzpeEuyogVD0f6to7sLEHDTZm5RqEqjzAD3If0j9G2cWpkk8fg&t=r"
  },
  {
    name: "Bank status",
    url:
      "https://service.eu.sumologic.com/ui/dashboard.html?k=mEPSWOkm7dgfUUaUldesHnpxiiY2Vgg5ZWAHoHHeqsDkO3p7Wt61PPED9ag4&t=r"
  },
  {
    name: "Transactions",
    url:
      "https://service.eu.sumologic.com/ui/dashboard.html?k=U72I4UEFKnf8hNNEWew3s3cJBtm5ffuqW9JfYZE4zfPx7ektqIu8vOaXbHXc&t=r"
  },
  {
    name: "Providers",
    url:
      "https://service.eu.sumologic.com/ui/dashboard.html?k=2XrOz5hZ3D8gFFr1uOQPoyB0FfoGPIh7rR3AKzV8l1h24jN8kcYPUO8jv0SE&t=r"
  },
  {
    name: "SMS",
    url:
      "https://service.eu.sumologic.com/ui/dashboard.html?k=pAu2QbQBCv2QMJupmhRYHD6wFc6uF8szEVBYiTibLdVCDtKLygF7QWPwdDkT&t=r"
  },
  {
    name: "Webhooks",
    url:
      "https://service.eu.sumologic.com/ui/dashboard.html?k=daS4zKABqrfffW4yi6DbyunRoUmfzJu8JAhYFwmGmech96uDu4oxwF8urRew&t=r"
  }
];
// tslint:enable:max-line-length

export default dashboards;
